import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserAuthService } from '../UserAuth.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  isAdmin = false;
  isSuperAdmin = false;

  private readonly _destroying$ = new Subject<void>();

  constructor(public userAuth: UserAuthService) {}

  ngOnInit(): void {
    this.userAuth.isAdmin$
      .pipe(takeUntil(this._destroying$))
      .subscribe((admin) => (this.isAdmin = admin));

    this.userAuth.isSuperAdmin$
      .pipe(takeUntil(this._destroying$))
      .subscribe((sa) => (this.isSuperAdmin = sa));
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
